import styled from 'styled-components'

export const FormWrapper = styled.div`
  margin: 20px 0;
`
export const Content = styled.div`
  padding: 20px 0;
  flex: 1;
  justify-content: center;
  display: flex;
  flex-direction: column;
`

export const ActingSectors = styled.div`
  margin: 20px 0;

  div {
    margin-top: 8px;
  }

  label {
    max-width: 85%;
  }
`
